export default __webpack_public_path__ + "static/media/icon-execution.860e885e.svg";